import React from 'react'
import { Link, graphql } from 'gatsby'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import { Seo } from '../components/SEO'
import FeaturedPost from '../components/FeaturedPost'

const blog = ({ data }) => {
  const blogData = data.allBlogPosts.edges
  return (
    <>
      <div className=' bg-white flex flex-col container pt-[85px] pb-[30px] md:pt-[110px] lg:pt-[112px]'>
        <h1 className='text-[32px]'>Blog</h1>
      </div>
      {blogData.length > 0 ? (
        <>
          <FeaturedPost featuredInfo={data.featuredPost} />
          <div className='bg-white container pt-[25px] pb-[80px] grid  auto-rows-fr grid-cols-1 gap-[15px] md:pt-[60px] md:gap-y-[50px] lg:gap-y-[60px]  md:grid-cols-2 lg:pt-[40px] lg:pb-[60px] lg:grid-cols-3'>
            {blogData.map((post, index) => {
              let image = getImage(post.node.featuredImage.node.localFile)
              return (
                <Link
                  to={`/blog/${post.node.slug}`}
                  key={index}
                  className='flex flex-col no-underline group'
                  data-aos='fade-up'
                  data-aos-duration='500'
                  data-aos-easing='ease-in-out'
                  data-aos-delay={index * 100}
                >
                  <div className='lg:h-[250px] md:h-[235px] h-[210px] overflow-hidden'>
                    <GatsbyImage
                      image={image}
                      alt={post.node.title}
                      className='w-full h-full object-cover group-hover:scale-110 transition-all ease-in-out duration-500'
                    />
                  </div>
                  <p className='text-xl pt-[10px] group-hover:text-orange transition-all'>
                    {post.node.title}
                  </p>
                </Link>
              )
            })}
          </div>
        </>
      ) : (
        <div className='bg-white container pt-[25px] pb-[80px] md:pt-[60px] md:gap-y-[50px] lg:gap-y-[60px] lg:pt-[40px] lg:pb-[60px]'>
          <h1>Blog is empty.</h1>
        </div>
      )}
    </>
  )
}

export const Head = () => (
  <Seo
    title='Blog | Vumo.ai'
    description='Learn more about used AI technology, major product updates, new possibilieties and find information about Vumo’s range of actions'
  />
)

export const query = graphql`
  query {
    allBlogPosts: allWpPost(
      filter: { categories: { nodes: { elemMatch: { name: { eq: "Blog" } } } } }
    ) {
      edges {
        node {
          slug
          title
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
        }
      }
    }
    featuredPost: allWpPost(
      filter: { categories: { nodes: { elemMatch: { name: { eq: "Blog" } } } } }
      limit: 1
      sort: { date: DESC }
    ) {
      edges {
        node {
          slug
          title
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: DOMINANT_COLOR)
                }
              }
            }
          }
          date(formatString: "DD.MM.YYYY")
          excerpt
        }
      }
    }
  }
`

export default blog
